<template>
  <footer id="footer" class="footer">
    <div class="footer__adv">
      <div class="footer__adv_item">
        <div class="footer__adv_item-svg">
          <svg
            id="vuesax_twotone_shield-tick"
            data-name="vuesax/twotone/shield-tick"
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 64 64"
          >
            <g id="shield-tick" transform="translate(0 0)">
              <path
                id="Vector"
                d="M22.9-1.5a13.818,13.818,0,0,1,4.582.71l.012,0L40.8,4.2a10.115,10.115,0,0,1,4.636,3.772,10.164,10.164,0,0,1,1.9,5.671V33.457a14.37,14.37,0,0,1-5.209,10.362L30.66,52.377a12.922,12.922,0,0,1-7.743,2.417,12.922,12.922,0,0,1-7.743-2.417L3.709,43.819A14.37,14.37,0,0,1-1.5,33.457V13.643A10.113,10.113,0,0,1,.4,7.995,10.128,10.128,0,0,1,5.037,4.227L18.34-.785A13.46,13.46,0,0,1,22.9-1.5Zm3.559,3.495A10.994,10.994,0,0,0,22.9,1.467a10.626,10.626,0,0,0-3.514.526L6.08,7a7.734,7.734,0,0,0-4.613,6.639V33.457a11.426,11.426,0,0,0,4.018,7.985L16.951,50l0,0a9.947,9.947,0,0,0,5.962,1.822A9.947,9.947,0,0,0,28.879,50l0,0,11.467-8.56a11.426,11.426,0,0,0,4.017-7.985V13.643A7.754,7.754,0,0,0,39.757,6.98Z"
                transform="translate(9.11 5.343)"
                fill="#ffa726"
              />
              <path
                id="Vector-2"
                data-name="Vector"
                d="M4.277,12.933A1.479,1.479,0,0,1,3.228,12.5L-1.066,8.206a1.483,1.483,0,0,1,0-2.1,1.483,1.483,0,0,1,2.1,0L4.277,9.352,14.694-1.066a1.483,1.483,0,0,1,2.1,0,1.483,1.483,0,0,1,0,2.1L5.326,12.5A1.479,1.479,0,0,1,4.277,12.933Z"
                transform="translate(24.15 24.497)"
                fill="#ffa726"
              />
              <path
                id="Vector-3"
                data-name="Vector"
                d="M0,0H64V64H0Z"
                transform="translate(64 64) rotate(180)"
                fill="none"
                opacity="0"
              />
            </g>
          </svg>
        </div>
        <p>پرداخت امن</p>
      </div>
      <div class="footer__adv_item">
        <div class="footer__adv_item-svg">
          <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              class="cls-1"
              d="M426.67,183.79a6.56,6.56,0,0,1-6.56-6.56c0-90.49-73.62-164.1-164.1-164.1S91.9,86.74,91.9,177.23a6.56,6.56,0,1,1-13.13,0C78.77,79.51,158.28,0,256,0S433.23,79.51,433.23,177.23A6.56,6.56,0,0,1,426.67,183.79Z"
            />
            <path
              class="cls-2"
              d="M52.51,223.18a39.38,39.38,0,1,0,0,78.77h0V223.18Z"
            />
            <path
              class="cls-1"
              d="M216.62,485.74c-76,0-137.85-61.84-137.85-137.85H91.9A124.86,124.86,0,0,0,216.62,472.62Z"
            />
            <path
              class="cls-3"
              d="M393.85,223.18v59.08c0,76-61.83,137.85-137.85,137.85S118.15,358.27,118.15,282.26V223.18H256c18.12,0,39.38-14.7,39.38-32.82,0,18.12,21.27,32.82,39.38,32.82Z"
            />
            <path
              class="cls-4"
              d="M256,354.46a45.67,45.67,0,0,1-34.19-15.34,6.56,6.56,0,1,1,9.82-8.71,32.65,32.65,0,0,0,48.73,0,6.56,6.56,0,1,1,9.82,8.71A45.67,45.67,0,0,1,256,354.46Z"
            />
            <circle class="cls-4" cx="216.62" cy="282.26" r="13.13" />
            <circle class="cls-4" cx="295.38" cy="282.26" r="13.13" />
            <path
              class="cls-5"
              d="M85.33,347.9h0a32.82,32.82,0,0,1-32.82-32.82V203.49a32.82,32.82,0,0,1,32.82-32.82h0a32.82,32.82,0,0,1,32.82,32.82V315.08A32.82,32.82,0,0,1,85.33,347.9Z"
            />
            <path
              class="cls-2"
              d="M459.49,223.18a39.38,39.38,0,1,1,0,78.77h0V223.18Z"
            />
            <path
              class="cls-5"
              d="M426.67,347.9h0a32.82,32.82,0,0,0,32.82-32.82V203.49a32.82,32.82,0,0,0-32.82-32.82h0a32.82,32.82,0,0,0-32.82,32.82V315.08A32.82,32.82,0,0,0,426.67,347.9Z"
            />
            <path
              class="cls-6"
              d="M393.52,223.18H334.77c-18.12,0-39.38-14.7-39.38-32.82,0,18.12-21.27,32.82-39.38,32.82H118.48C122,150.25,182.22,91.9,256,91.9S390,150.25,393.52,223.18Z"
            />
            <path
              class="cls-7"
              d="M301.95,479.18A32.83,32.83,0,0,1,269.13,512H242.87a32.82,32.82,0,0,1,0-65.64h26.26A32.83,32.83,0,0,1,301.95,479.18Z"
            />
            <g class="cls-8">
              <path
                d="M301.95,479.18A32.83,32.83,0,0,1,269.13,512H256V446.36h13.13A32.83,32.83,0,0,1,301.95,479.18Z"
              />
            </g>
            <g class="cls-8">
              <path
                d="M393.85,223.18v59.08c0,76-61.83,137.85-137.85,137.85V91.9c73.78,0,134,58.35,137.52,131.28Z"
              />
            </g>
          </svg>
        </div>
        <p class="advp" style="direction: rtl">پشتیبانی در ۷ روز هفته</p>
      </div>
      <div class="footer__adv_item">
        <div class="footer__adv_item-svg">
          <!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 511.984 511.984"
            style="enable-background: new 0 0 511.984 511.984"
            xml:space="preserve"
          >
            <rect
              x="30.921"
              y="165.122"
              style="fill: #ffce54"
              width="448.99"
              height="310.02"
            />
            <rect
              x="324.682"
              y="270.932"
              style="fill: #4fc2e9"
              width="93.47"
              height="196.42"
            />
            <rect
              x="35.498"
              y="36.842"
              style="fill: #e6e9ed"
              width="439.25"
              height="64.811"
            />
            <rect
              x="84.372"
              y="272.022"
              style="fill: #4fc2e9"
              width="192.43"
              height="128.29"
            />
            <g>
              <path
                style="fill: #f5f7fa"
                d="M73.684,261.336v149.667h213.807V261.336H73.684z M266.1,389.613H95.059V282.71H266.1V389.613z"
              />
              <path
                style="fill: #f5f7fa"
                d="M308.865,261.336v213.806h128.278V261.336H308.865z M415.768,453.767h-85.529V282.71h85.529V453.767
		z"
              />
            </g>
            <g>
              <path
                style="fill: #3bafda"
                d="M244.648,336.162c-2.969,0-5.625,1.203-7.562,3.141l0,0l-21.374,21.373l0,0
		c-1.938,1.938-3.141,4.609-3.141,7.562c0,5.906,4.797,10.688,10.703,10.688c2.938,0,5.609-1.188,7.547-3.125l0,0l21.39-21.39l0,0
		c1.922-1.922,3.125-4.609,3.125-7.547C255.336,340.958,250.554,336.162,244.648,336.162z"
              />
              <path
                style="fill: #3bafda"
                d="M252.211,311.662c1.922-1.938,3.125-4.609,3.125-7.562c0-5.906-4.781-10.687-10.688-10.687
		c-2.969,0-5.625,1.188-7.562,3.125l-64.139,64.138c-1.938,1.938-3.141,4.609-3.141,7.562c0,5.906,4.781,10.688,10.688,10.688
		c2.969,0,5.625-1.188,7.562-3.125L252.211,311.662z"
              />
            </g>
            <path
              style="fill: #f5f7fa"
              d="M418.143,357.552h-98.591c-5.906,0-10.688,4.78-10.688,10.687s4.781,10.688,10.688,10.688h98.591
	c5.906,0,10.688-4.781,10.688-10.688S424.05,357.552,418.143,357.552z"
            />
            <path
              style="fill: #da4453"
              d="M450.892,239.961c33.733,0,61.092-27.358,61.092-61.092c0-3.25-0.266-6.438-0.75-9.546l0,0
	l-0.344-1.922c-0.062-0.297-0.109-0.594-0.156-0.891l-35.405-86.904h-87.966l14.655,135.918l2.062,2.594
	C415.3,231.461,432.096,239.961,450.892,239.961z"
            />
            <path
              style="fill: #e6e9ed"
              d="M299.397,79.606l4.874,135.918c11.156,14.828,28.905,24.437,48.874,24.437
	c19.999,0,37.717-9.609,48.873-24.437L387.363,79.606H299.397z"
            />
            <path
              style="fill: #da4453"
              d="M61.076,239.961C27.343,239.961,0,212.603,0,178.869c0-3.25,0.249-6.438,0.749-9.546H0.733
	l0.359-1.922c0.047-0.297,0.094-0.594,0.156-0.891l35.405-86.904h87.951l-14.672,135.918l-2.047,2.594
	C96.684,231.461,79.872,239.961,61.076,239.961z"
            />
            <path
              style="fill: #e6e9ed"
              d="M212.571,79.606l-4.891,135.918c-11.14,14.828-28.874,24.437-48.873,24.437
	c-19.969,0-37.718-9.609-48.874-24.437l14.672-135.918H212.571z"
            />
            <path
              style="fill: #da4453"
              d="M211.43,79.606l-4.875,135.918c11.125,14.828,28.875,24.437,48.858,24.437
	s37.733-9.609,48.857-24.437l-4.874-135.918H211.43z"
            />
            <path
              style="fill: #ed5564"
              d="M1.186,166.838c-0.031,0.188-0.062,0.375-0.094,0.562l-0.359,1.922h0.016
	C0.249,172.431,0,175.618,0,178.868c0,33.733,27.343,61.092,61.076,61.092c18.796,0,35.608-8.5,46.811-21.843l2.047-2.594
	l5.266-48.686H1.186V166.838z"
            />
            <path
              style="fill: #f5f7fa"
              d="M115.199,166.838l-5.266,48.686c11.156,14.828,28.905,24.437,48.874,24.437
	c19.999,0,37.733-9.609,48.873-24.437l1.75-48.686H115.199z"
            />
            <path
              style="fill: #ed5564"
              d="M208.305,166.838l-1.75,48.686c11.125,14.828,28.875,24.437,48.858,24.437
	s37.733-9.609,48.857-24.437l-1.749-48.686H208.305z"
            />
            <path
              style="fill: #f5f7fa"
              d="M302.522,166.838l1.749,48.686c11.156,14.828,28.905,24.437,48.874,24.437
	c19.999,0,37.717-9.609,48.873-24.437l-5.25-48.686H302.522z"
            />
            <path
              style="fill: #ed5564"
              d="M511.234,169.323l-0.344-1.922c-0.031-0.188-0.078-0.375-0.109-0.562H396.768l5.25,48.686
	l2.062,2.594c11.219,13.343,28.016,21.843,46.812,21.843c33.733,0,61.092-27.358,61.092-61.092
	C511.984,175.619,511.719,172.431,511.234,169.323L511.234,169.323z"
            />
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </svg>
        </div>
        <p>تنوع کالا</p>
      </div>
      <div class="footer__adv_item">
        <div class="footer__adv_item-svg">
          <!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
          <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 511.76 511.76"
            style="enable-background: new 0 0 511.76 511.76"
            xml:space="preserve"
          >
            <polygon
              style="fill: #e95454"
              points="151.352,221.248 39.592,431.808 141.08,422.432 190.2,511.744 301.96,301.184 "
            />
            <g>
              <path
                style="fill: #ed6362"
                d="M164.152,450.432c3.136-6.736-0.144-14.784-6.704-18.272l-6.432-3.424
		c-6.432-3.664-8.88-11.808-5.376-18.4c3.552-6.704,11.904-9.264,18.608-5.712l18.176,9.648c5.616,2.976,12.656,0.816,15.552-4.832
		l0.448-0.864c3.328-5.328,1.36-12.368-4.176-15.296l-54.368-28.848c-6.624-3.52-9.872-11.536-6.784-18.288
		c3.408-7.184,12.016-10.016,18.944-6.336l50.432,26.768c5.616,2.976,12.656,0.816,15.632-4.8l0.288-0.736l0.08-0.16
		c3.216-5.888,0.96-13.28-4.976-16.432l-28.288-15.008c-6.624-3.52-9.872-11.536-6.736-18.368
		c3.376-7.104,12.016-10.016,18.944-6.336l31.248,16.592c5.84,3.104,12.816,0.512,15.84-5.376c0.048-0.08,0.048-0.08,0.08-0.16
		c0.048-0.08,0.048-0.08,0.08-0.16c3.184-5.808,1.424-13.04-4.432-16.128l-33.712-17.888c-6.544-3.472-9.792-11.488-6.704-18.24
		c3.408-7.184,12.016-10.016,18.944-6.336l83.168,44.144l-111.76,210.56l-30.8-55.984
		C161.352,454.416,163.08,452.752,164.152,450.432z"
              />
              <polygon
                style="fill: #ed6362"
                points="360.408,221.248 472.168,431.808 370.68,422.432 321.56,511.744 209.8,301.184 	"
              />
            </g>
            <path
              style="fill: #e95454"
              d="M347.608,450.432c-3.136-6.736,0.144-14.784,6.704-18.272l6.432-3.424
	c6.432-3.664,8.88-11.808,5.376-18.4c-3.552-6.704-11.904-9.264-18.608-5.712l-18.176,9.648c-5.616,2.976-12.656,0.816-15.552-4.832
	l-0.448-0.864c-3.328-5.328-1.36-12.368,4.176-15.296l54.384-28.864c6.624-3.52,9.872-11.536,6.784-18.288
	c-3.408-7.184-12.016-10.016-18.944-6.336l-50.432,26.768c-5.616,2.976-12.656,0.816-15.632-4.8l-0.288-0.736l-0.08-0.16
	c-3.216-5.888-0.96-13.28,4.976-16.432l28.288-15.008c6.624-3.52,9.872-11.536,6.736-18.368
	c-3.376-7.104-12.016-10.016-18.944-6.336l-31.28,16.624c-5.84,3.104-12.816,0.512-15.84-5.376c-0.048-0.08-0.048-0.08-0.08-0.16
	c-0.048-0.08-0.048-0.08-0.08-0.16c-3.184-5.808-1.424-13.04,4.432-16.128l33.712-17.888c6.544-3.472,9.792-11.488,6.704-18.24
	c-3.408-7.184-12.016-10.016-18.944-6.336L209.816,301.2l111.76,210.56l30.8-55.984C350.408,454.416,348.68,452.752,347.608,450.432
	z"
            />
            <circle
              style="fill: #ffcc5b"
              cx="255.88"
              cy="186.736"
              r="186.736"
            />
            <path
              style="fill: #fdbc4b"
              d="M281.208,165.312H162.872c-9.2,0-16.752-7.552-16.752-16.752l0.128-1.152v-0.256
	c-0.128-9.712,7.792-17.648,17.52-17.648h82.016c10.864,0,20.464-8.048,21.104-18.928C267.4,99.2,258.328,89.6,246.936,89.6h-86.88
	c-9.584,0-16.752-8.048-16.624-17.648c0-0.128,0-0.128,0-0.256s0-0.128,0-0.256c-0.128-9.584,7.024-17.648,16.624-17.648h90.912
	c10.736,0,20.336-8.048,20.976-18.8c0.512-11.504-8.56-20.976-19.952-20.976h-66.576C117.528,42,69.688,108.752,69.688,186.736
	s47.84,144.72,115.744,172.672h84.528c10.736,0,20.336-8.048,20.976-18.8c0.512-11.504-8.56-20.96-19.952-20.96l-96.16-0.016
	c-11.344,0-20.48-9.488-19.872-20.976c0.56-10.752,10.224-18.832,20.992-18.832h37.28c10.72-0.304,19.376-9.088,19.376-19.888
	c0-10.992-8.944-19.952-19.952-19.952h-56.512c-9.2,0-16.752-7.536-16.624-16.752v-1.408c-0.64-9.072,6.656-16.752,15.728-16.752
	h124.816c10.864,0,20.464-8.048,21.104-18.8C301.672,174.784,292.584,165.312,281.208,165.312z"
            />
            <path
              style="fill: #ffdb70"
              d="M255.88,320.016c-73.504,0-133.296-59.808-133.296-133.296S182.376,53.44,255.88,53.44
	s133.296,59.808,133.296,133.296S329.384,320.016,255.88,320.016z"
            />
            <path
              style="opacity: 0.2; fill: #ffffff; enable-background: new"
              d="M389.176,186.736c0-70.912-55.712-128.912-125.648-132.912
	h-12.416c-8.192,0-15.504,6.144-16,14.336c-0.384,8.768,6.528,16,15.216,16l73.344,0.016c8.656,0,15.616,7.232,15.152,16
	c-0.432,8.208-7.792,14.368-16.016,14.368h-28.432c-8.176,0.24-14.784,6.928-14.784,15.168c0,8.384,6.832,15.216,15.216,15.216
	h43.104c7.024,0,12.768,5.76,12.672,12.768v1.056c0.48,6.928-5.072,12.768-12,12.768H243.4c-8.288,0-15.6,6.144-16.096,14.336
	c-0.384,8.768,6.528,16,15.216,16h90.24c7.024,0,12.768,5.76,12.768,12.768l-0.096,0.88v0.192
	c0.096,7.408-5.952,13.456-13.36,13.456h-62.56c-8.288,0-15.6,6.144-16.096,14.432c-0.384,8.672,6.528,16,15.216,16h66.256
	c7.312,0,12.768,6.144,12.672,13.456c0,0.096,0,0.096,0,0.192c0,0.096,0,0.096,0,0.192c0.096,7.312-5.36,13.456-12.672,13.456
	H265.56c-8.192,0-15.504,6.144-16,14.336c-0.384,8.784,6.528,16,15.216,16h18.288C343.592,304.608,389.176,250.896,389.176,186.736z
	"
            />
            <path
              style="fill: #ec9922"
              d="M348.936,157.216h-64.832l-20.048-61.664c-2.576-7.92-13.792-7.92-16.368,0l-20.032,61.664h-64.832
	c-8.336,0-11.808,10.672-5.056,15.568l52.448,38.112l-20.032,61.664c-2.576,7.92,6.496,14.512,13.248,9.616l52.448-38.112
	l52.448,38.112c6.752,4.896,15.824-1.696,13.248-9.616l-20.032-61.664l52.448-38.112
	C360.728,167.888,357.272,157.216,348.936,157.216z"
            />
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </svg>
        </div>
        <p>ضمانت کالا</p>
      </div>
    </div>
    <hr />
    <div class="footer_soc">
      <a :href="'mailto:' + footer.email">
        <font-awesome-icon :icon="['fab', 'google']" />
      </a>
      <a :href="footer.telegram" target="_blank">
        <font-awesome-icon :icon="['fab', 'telegram']" />
      </a>
      <a :href="footer.instagram" target="_blank">
        <font-awesome-icon :icon="['fab', 'instagram']" />
      </a>
    </div>
    <div class="footer_number">
      <p v-for="(item, index) in phones" :key="(item, index)">
        <font-awesome-icon icon="phone" />
        {{ item.toPersianDigits() }}
      </p>
      <!-- <p>
        <font-awesome-icon icon="phone" />
        {{ this.phones.two }}
      </p>
      <p>
        <font-awesome-icon icon="phone" />
        {{ this.phones.three }}
      </p> -->
      <!-- <a :href="$store.state.index.base.telegram">
        <font-awesome-icon :icon="['fab', 'telegram']" />
      </a>
      <a :href="$store.state.index.base.instagram">
        <font-awesome-icon :icon="['fab', 'instagram']" />
      </a> -->
    </div>
    <div style="color: var(--shrink)" class="footer_number">
      <p>
        شماره های تماس فقط برای پیگیری های ضروری است
        <!-- <font-awesome-icon icon="phone" /> -->
      </p>
    </div>
    <hr />
    <div class="footer_spe">
      <div class="footer_spe__con1">
        <p class="footer_spe__con1--p">
          فروشگاه اینترنتی {{ footer.fa_title }}
        </p>
        <p v-html="footer.footer_desc" class="footer_spe__con1--pp"></p>
      </div>
      <!-- <div class="footer_spe__con2">
        <a :href="trade.link1">
          <img :src="trade.img1" alt="symbol" />
        </a>
        <a :href="trade.link2">
          <img :src="trade.img2" alt="symbol" />
        </a>
      </div> -->
    </div>
    <hr />
    <!-- <div class="footer__copy">
      .کلیه حقوق این سایت متعلق به فروشگاه
      {{ footer.fa_title }} می باشد
    </div>
    <div style="font-size: .6em ; direction :rtl" class="footer__copy">
      developed by Abnoce team
    </div> -->
  </footer>
</template>
<script>
export default {
  data() {
    return {
      phones: [],
      footer: [],
      trade: {
        img1: "",
        img2: "",
        link1: "",
        link2: "",
      },
    };
  },
  created() {
    var that = this;
    String.prototype.toPersianDigits = function () {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function (w) {
        return id[+w];
      });
    };
    if (localStorage.getItem("profile") == null) {
      $.ajax({
        url: that.$store.state.url + "api/v1/pages/footer/",
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          that.footer = data;
          // console.log(data.phones, "footer");
          that.phones = data.phones;
          // that.trade.img1 = data.symbols[0].image;
          // that.trade.link1 = data.symbols[0].link;
          // that.trade.img2 = data.symbols[1].image;
          // that.trade.link2 = data.symbols[1].link;
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {},
      });
    } else {
      $.ajax({
        url: that.$store.state.url + "api/v1/pages/footer/",
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("profile"),
        },
        type: "GET",
        success: function (data, textStatus, request) {
          that.footer = data;
          // console.log(data.phones, "footer");
          that.phones = data.phones;
          // that.trade.img1 = data.symbols[0].image;
          // that.trade.link1 = data.symbols[0].link;
          // that.trade.img2 = data.symbols[1].image;
          // that.trade.link2 = data.symbols[1].link;
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {},
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.footer {
  // position: absolute;
  bottom: 0;
  width: 100%;
  height: auto;
  background: #eceff1;
  margin-top: 2em;
  border-top: 1px solid #cfd8dc;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.171);
  display: flex;
  flex-direction: column;
  align-items: center;
  &_number {
    // background: red;
    width: 100%;
    justify-content: space-around;
    margin: 1em 0;
    display: flex;
    a {
      text-decoration: none;
      color: var(--font-color);
    }
    svg {
      margin-right: 0.2em;
    }
    @media screen and (max-width: 500px) {
      font-size: 0.6em;
    }
  }
  &__copy {
    background: #d7dee0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2em;
    @media screen and (max-width: 500px) {
      font-size: 0.8em;
    }
  }
  &_spe {
    width: 100%;
    height: auto;
    padding: 3em 5em;
    direction: rtl;
    display: flex;
    background: #d7dee0;
    @media screen and (max-width: 500px) {
      flex-direction: column;
      padding: 2em 2em;
    }
    @media screen and (max-width: 1000px) {
      flex-direction: column;
      padding: 2em 2em;
    }
    &__con1 {
      width: 50%;
      @media screen and (max-width: 500px) {
        width: 100%;
        text-align: justify;
        margin-bottom: 3em;
      }
      @media screen and (max-width: 1000px) {
        width: 100%;
        text-align: justify;
        margin-bottom: 3em;
      }
      &--p {
        font-size: 1.5em;
        margin-bottom: 0.5em;
        @media screen and (max-width: 500px) {
          font-size: 1.2em;
        }
        @media screen and (max-width: 1000px) {
          font-size: 1.2em;
        }
      }
      &--pp {
        font-size: 0.8em;
        @media screen and (max-width: 500px) {
          font-size: 0.7em;
        }
        @media screen and (max-width: 1000px) {
          font-size: 0.8em;
        }
      }
    }
    &__con2 {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      @media screen and (max-width: 500px) {
        width: 100%;
      }
      @media screen and (max-width: 1000px) {
        width: 100%;
      }
      img {
        z-index: 0;
        border-radius: 10px;
        padding: 0.5em;
        border: 1px solid var(--bg-color);
        margin: 1em;
        width: 130px;
        height: 130px;
        position: relative;
        @media screen and (max-width: 500px) {
          width: 110px;
          // padding-top: 1em !important;
          height: 110px;
        }
      }
    }
  }
  &_soc {
    font-size: 3em;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    @media screen and (max-width: 500px) {
      font-size: 2em;
      margin-bottom: 0;
    }
    a {
      text-decoration: none;
      color: var(--sub-color);
      transition: all 0.5s;
    }
    a:hover {
      transform: rotate(360deg);
    }
  }
  &__adv {
    width: 100%;
    height: 130px;
    // background: var(--bg-color);
    display: flex;
    justify-content: space-around;
    align-items: center;

    @media screen and (max-width: 500px) {
      height: 130px;
      font-size: 0.7em;
    }
    &_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &-svg {
        width: 50px;
        @media screen and (max-width: 500px) {
          // height: 20px;
          font-size: 0.2em;
        }
        svg {
          width: 50px;
          @media screen and (max-width: 500px) {
            height: 30px;
          }
        }
      }
    }
  }
}
hr {
  width: 85%;
  border: none;
  height: 1px;
  background-color: #cfd8dc;
}
// .advp {
//   // color: red;
//   // background: red;
//   // padding-top: -5em;
//   transform: translate(0px, -75px);
//   @media screen and (max-width: 500px) {
//     transform: translate(0px, -0px);
//   }
// }
.cls-1 {
  fill: #c0ccdd;
}
.cls-2 {
  fill: var(--shrink);
}
.cls-3 {
  fill: #ffcf99;
}
.cls-4 {
  fill: #d39f75;
}
.cls-5 {
  fill: gold;
}
.cls-6 {
  fill: #5e5349;
}
.cls-7 {
  fill: #f7818f;
}
.cls-8 {
  opacity: 0.06;
}
</style>



// WEBPACK FOOTER //
// src/components/main/footer.vue